"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var useCategoryTree = function useCategoryTree(lang, fetchedCategoryTree) {
  return (0, _swr["default"])(["useCategoryTree"], _fetcher["default"], {
    initialData: fetchedCategoryTree
  });
};
var _default = useCategoryTree;
exports["default"] = _default;